module.exports = __webpack_public_path__ + "static/media/Millas.60c79d70.png";